import React, { useState } from "react"

interface Tab {
  title: string
  content: React.ReactNode
}

interface TabMenuProps {
  tabs: Tab[]
  defaultActiveTab?: number
}

const TabMenu = ({ tabs, defaultActiveTab = 0 }: TabMenuProps) => {
  const [activeTab, setActiveTab] = useState<number>(defaultActiveTab)

  return (
    <div className="w-full mx-auto">
      <div className="flex border-b border-customGrey-400 gap-4">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={`flex flex-col pt-2 pr-4 focus:outline-none ${
              activeTab === index
                ? " text-[var(--theme-black)] font-bold"
                : "text-textGrey-100 text-base font-medium"
            }`}
          >
            {tab.title}

            <span
              className={`${
                activeTab === index
                  ? " border-b-4 border-[var(--theme-black)] w-full rounded-t-md"
                  : ""
              }`}
            />
          </button>
        ))}
      </div>
      <div className="">
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`${
              activeTab === index ? "block" : "hidden"
            } text-gray-700`}
          >
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  )
}

export default TabMenu
